<i18n>
{
  "fr": {
    "sending_control_attachments_to_ged": "Envoi des piéces jointes liées au contrôle en GED",
    "send_control_attachments_to_ged": "Envoyer les pièces jointes en GED",
    "synchronization_date_time": "Date de derniére synchronisation",
    "synchronized_by": "Effectuée par"
    }
}
</i18n>

<template>
  <div class="panel panel-info text-left">
    <div class="panel-heading">{{ $t('sending_control_attachments_to_ged') }}</div>
    <div class="panel-body">
      <form @submit.prevent="handleSubmitControlAttachementsToGed">
        <b-button
          type="submit"
          class="btn btn-cta s-btn disp-msg"
          v-bind:disabled="submitControlAttachementsToGed || dateOfVisitExist"
        >
          <b-spinner v-if="submitControlAttachementsToGed" />
          {{ $t('send_control_attachments_to_ged') }}
        </b-button>
        <span v-if="dateOfVisitExist" class="ndisp red">Date de visite non saisie</span>
      </form>

      <br />

      <div class="row">
        <div class="col-sm-12">
          {{ $t('synchronization_date_time') }} :
          <span
            v-if="lastHistory"
          >{{ lastHistory.createdAt | moment("DD/MM/YYYY \à HH:mm") }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          {{ $t('synchronized_by') }} :
          <span
            v-if="lastHistory"
          >{{ lastHistory.lastName }} {{ lastHistory.firstName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';

export default {
  name: 'SendControlAttachmentsToGed',
  components: {
    //
  },
  props: {
    contractId: String,
    propertyId: String,
    controlId: String,
    dateOfVisit: String,
  },
  data() {
    return {
      submitControlAttachementsToGed: false,
      dateOfVisitExist: false,
      synchronizationHistories: [],
    };
  },
  mounted() {
    this.jwtDecoded = VueJwtDecode.decode(this.$store.state.app.parameters.jwt);

    if (this.dateOfVisit === null) {
      this.dateOfVisitExist = true;
    }

    this.getHistories(this.propertyId, this.controlId);
  },
  computed: {
    lastHistory() {
      let lastHistory = null;
      this.synchronizationHistories.forEach(history => {
        if (lastHistory == null || history.createdAt > lastHistory.createdAt) {
          lastHistory = history;
        }
      });
      return lastHistory;
    },
  },
  methods: {
    handleSubmitControlAttachementsToGed() {
      this.submitControlAttachementsToGed = true;
      let formData = new FormData();
      let _this = this;

      axios
        .post(`/fr/import-export/${this.contractId}/control/${this.controlId}/import-attachments-to-ged`, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(function() {
          axios({
            method: 'post',
            url: `/fr/proprietes/${_this.propertyId}/history/control/${_this.controlId}`,
            data: {
              user: _this.jwtDecoded.data.user,
            },
          });
        })
        .then(() => {
          this.submitControlAttachementsToGed = false;
          _this.getHistories(this.propertyId, this.controlId);
        });
    },
    getHistories(propertyId, controlId) {
      let _this = this;

      axios
        .get(`/fr/proprietes/${propertyId}/history/control/${controlId}`, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(function(response) {
          _this.synchronizationHistories = response.data;
        })
        .catch(function() {
          console.log('FAILURE!!');
        });
    },
    getLastHistory() {
      let createdAt = null;
      let lastHistory = null;
      this.synchronizationHistories.forEach(history => {
        if (createdAt == null || history.createdAt > createdAt) {
          createdAt = history.createdAt;
        }
      });
      return lastHistory;
    },
  },
};
</script>
